import { Route, Routes, BrowserRouter } from "react-router-dom";
import React, { Suspense, useEffect } from "react";
import Home from "../pages/Home";
import MainPolicyPage from "../pages/policies/MainPolicyPage";
import ManageSubscription from "../pages/ManageSubscription";

const AppRoute = () => {
  useEffect(() => {
    // MoEngageInitialization();
  }, []);
  return (
    <BrowserRouter basename="/">
      <Suspense fallback={"Loading..."}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/manage-subscription" element={<ManageSubscription />} />
          <Route path="*" element={<Home />} />

          <Route path="/policy/:pagename" element={<MainPolicyPage />} />

          {/* Funnel  */}
          {/* <Route path="/Quiz/what-is-your-name" element={<UserName />} /> */}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};
export default AppRoute;
